import { render, staticRenderFns } from "./DialogEdit.vue?vue&type=template&id=a22cd756&scoped=true"
import script from "./DialogEdit.vue?vue&type=script&lang=js"
export * from "./DialogEdit.vue?vue&type=script&lang=js"
import style0 from "./DialogEdit.vue?vue&type=style&index=0&id=a22cd756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22cd756",
  null
  
)

export default component.exports